import common from 'store/modules/common/api'

export const api = {
  ...common.apiMethods('WinesInStock'),
  getBottlesOfWineStock: ({ wineId }) => common.httpClient.get(`/api/services/app/WinesInStock/GetBottlesOfWineInStock?wineId=${wineId}`, common.options()).then(r => common.processResponse(r)),
}